<div class="floors-elevation-wrapper">
  <form [formGroup]="form">
    <mat-table [dataSource]="floorsFormArray.controls" formArrayName="Floors">
      <ng-container matColumnDef="IsEnabled">
        <mat-header-cell *matHeaderCellDef>{{ "FloorsConfiguration.EnabledColumn" | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let floor; let i = index" [formGroupName]="i">
          <mat-checkbox formControlName="IsEnabled" class="hidden-checkbox"></mat-checkbox>
          <i
            class="material-icons enable-state-icon"
            (click)="changeEnableState(floor, i)"
            [ngClass]="{
              'green-color': getFormValueByKey('IsEnabled', i),
              'red-color': !getFormValueByKey('IsEnabled', i),
              disabled: isTeamAdmin
            }"
          >
            {{ getFormValueByKey("IsEnabled", i) ? "done" : "close" }}
          </i>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Name">
        <mat-header-cell *matHeaderCellDef>{{ "FloorsConfiguration.NameColumn" | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let floor; let i = index">{{ getFormValueByKey("Name", i) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Elevation">
        <mat-header-cell *matHeaderCellDef>{{ "FloorsConfiguration.Elevation" | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let floor; let i = index" [formGroupName]="i">
          <input formControlName="Elevation" class="elevation-input" matInput type="number" />
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </form>
</div>
